import React from 'react';
import { observer } from 'mobx-react';

import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import computed from 'lib/mobx/computed';
import Styled from 'styled';
import withDialog from 'lib/alerts/with-dialog';
import LinkView from 'lib/ui/link-view';
import withInnerRef from 'lib/react/with-inner-ref';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import pen from 'four-nets/icons/svg/icon_pen.svg';
import camera from 'four-nets/icons/svg/icon_camera.svg';

import { CategoryLink } from '../../category-link';
import defaultStyles from './blog-post-status-bar-view.scss';
import iconStyles from './icon.scss';

export class BlogPostStatusBarViewModel {
    post: Post;
    urlBuilder: URLBuilder;

    @computed get categoryLinks() {
        return this.post.categories.map(category => new CategoryLink(category));
    }

    constructor(options) {
        const { post, urlBuilder } = options;
        this.urlBuilder = urlBuilder;
        this.post = post;
    }
}

@withDialog
@Styled(defaultStyles)
@observer
class BlogPostStatusBarView extends React.Component {
    render() {
        const { blogPostStatusBarViewModel, styles } = this.props;
        const { post, categoryLinks } = blogPostStatusBarViewModel;

        return (
            <div className={styles.statusBar}>
                <ul className={styles.categories}>
                    {categoryLinks.map((link, index) => (
                        <li key={link.category.id} className={styles.item}>
                            <LinkView link={link} className={styles.link}>
                                {link.category.name}
                            </LinkView>
                            {index !== categoryLinks.length - 1 ? <div className={styles.delimiter} /> : null}
                        </li>
                    ))}
                </ul>
                <ul className={styles.items}>
                    <li className={styles.item}>
                        <FormattedDateAgoView value={post.date} />
                    </li>
                    {post.displayedAuthor ? (
                        <li className={styles.item}>
                            <SVGIcon style={{ image: iconStyles.icon }} src={pen} />
                            {post.displayedAuthor}
                        </li>
                    ) : null}
                    {post.photoSource ? (
                        <li className={styles.item}>
                            <SVGIcon style={{ image: iconStyles.icon }} src={camera} />
                            {post.photoSourceUrl ? (
                                <a className={styles.photoSourceLink} target='_blank' href={post.photoSourceUrl}>
                                    {post.photoSource}
                                </a>
                            ) : (
                                post.photoSource
                            )}
                        </li>
                    ) : null}
                </ul>
            </div>
        );
    }
}

export default BlogPostStatusBarView;
